import { type DeviceResponse, toDevice } from 'src/models/apis/device/deviceResponse';

export type AdminDeviceIndexResponse = DeviceResponse[];

export const toAdminDevice = toDevice;
